import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { required: Boolean }
  static targets = ['checkbox']

  initialize() {
    this.checkboxTarget.updateComplete.then(() => {
      if (this.requiredValue) {
        this.checkboxTarget.setCustomValidity('Select at least one tickbox')
      }
    })
  }

  validate() {
    if (!this.requiredValue) { return }

    if (this.checkboxTargets.some(checkbox => checkbox.checked)) {
      this.checkboxTarget.setCustomValidity('')
    } else {
      this.checkboxTarget.setCustomValidity('Select at least one tickbox')
    }
  }
}
